var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardicn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.783,
    height: 45.996,
    viewBox: "0 0 37.783 45.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(-522 -1605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    d: "M8614.764,1606.682l19.824,8.1-19.824,8.544Z",
    transform: "translate(-8080.415 -0.055)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 17.898,
    cy: 6.772,
    rx: 17.898,
    ry: 6.772,
    transform: "translate(522.967 1636.926)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(522 1605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-28-golf",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "golf",
    d: "M16.5,12.678V33.8C9.739,34.925,5,37.548,5,40.6,5,44.687,13.458,48,23.891,48s18.891-3.31,18.891-7.392-8.458-7.392-18.891-7.392a46.568,46.568,0,0,0-5.75.349h0V21.009L39.5,11.856,16.5,2V12.678Zm1.643,22.5a49.381,49.381,0,0,1,5.75-.327c9.526,0,17.249,2.574,17.249,5.75s-7.722,5.75-17.249,5.75S6.643,43.779,6.643,40.6c0-2.294,4.029-4.273,9.856-5.2v2.781c-1.875.228-3.285,1.223-3.285,2.415,0,1.361,1.839,2.464,4.107,2.464s4.107-1.1,4.107-2.464c0-1.192-1.411-2.186-3.285-2.415V35.182Zm0-30.718V19.249L35.39,11.856,18.142,4.464Zm12.32,36.961c1.361,0,2.464-.735,2.464-1.643s-1.1-1.643-2.464-1.643S28,38.875,28,39.783s1.1,1.643,2.464,1.643Z",
    transform: "translate(-5 -2)",
    fill: "#1a5186",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicn);
export default __webpack_public_path__ + "static/media/cardicn.7fdcf0fdea6299a578018a90144061c9.svg";
export { ForwardRef as ReactComponent };